import React, { useRef } from "react";
import { Camera, MapPin, X, AlertOctagon } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { VoiceNoteRecorder } from "@/components/VoiceNoteRecorder";

// Photo grid + capture button + GPS error banner + voice note recorder.
// Parent owns the photos array & voice-note state; this is a controlled view.
export function PhotoCapture({ photos, onAdd, onRemove, gpsErr, onVoiceRecorded, onVoiceRemoved }) {
  const { t } = useLang();
  const fileRef = useRef();

  return (
    <section className="hag-surface p-4 mt-4" data-testid="photos-panel">
      <h3 className="text-sm font-bold uppercase tracking-widest text-[#4A627A] mb-3">{t("photos")} (1-6)</h3>
      <div className="grid grid-cols-3 gap-2">
        {photos.map((p) => (
          <div key={p.id} className="relative">
            <img src={p.blobUrl} alt="captured" className="w-full h-24 object-cover rounded-md border border-[#1B3A5C]/10" />
            <button
              data-testid={`remove-photo-${p.id}`}
              onClick={() => onRemove(p.id)}
              className="absolute top-1 right-1 bg-black/60 text-white rounded-full w-6 h-6 flex items-center justify-center"
            >
              <X size={12} />
            </button>
            <div className="absolute bottom-1 left-1 bg-black/60 text-white text-[10px] px-1 rounded flex items-center gap-1">
              <MapPin size={10} /> {p.gps_lat.toFixed(3)}
            </div>
          </div>
        ))}
        {photos.length < 6 && (
          <button
            data-testid="add-photo-btn"
            onClick={() => fileRef.current.click()}
            className="h-24 rounded-md border-2 border-dashed border-[#1B3A5C]/25 flex flex-col items-center justify-center gap-1 text-[#4A627A]"
          >
            <Camera size={22} /><span className="text-xs">{t("add_photo")}</span>
          </button>
        )}
      </div>
      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        capture="environment"
        className="hidden"
        onChange={(e) => { if (e.target.files?.[0]) onAdd(e.target.files[0]); e.target.value = ""; }}
      />
      {gpsErr && (
        <div data-testid="gps-err" className="mt-2 text-sm text-red-700 bg-red-50 border border-red-200 rounded-md p-2 flex items-center gap-2">
          <AlertOctagon size={14} /> {gpsErr}
        </div>
      )}
      <VoiceNoteRecorder onRecorded={onVoiceRecorded} onRemove={onVoiceRemoved} />
    </section>
  );
}
